import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalPath?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({ title, description, keywords, canonicalPath, ogType = 'website', ogImage, schema }: SEOHeadProps) {
  const location = useLocation();
  const canonicalUrl = `https://www.nangong-group.com${canonicalPath || location.pathname}`;

  const fullTitle = title.includes('南宫集团') ? title : `${title} - 南宫集团`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description.substring(0, 160)} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description.substring(0, 160)} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="南宫集团" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description.substring(0, 160)} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      <meta name="geo.region" content="CN-BJ" />
      <meta name="geo.placename" content="北京市" />
      <meta name="geo.position" content="39.9042;116.4074" />

      {schema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      )}
    </>
  );
}